/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_S6_Li4Inputs */

const en_guide_json_syntax_errors_s6_li4 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove any comments (<code>//</code> or <code>/* */</code>)`)
};

const ko_guide_json_syntax_errors_s6_li4 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`주석(<code>//</code> 또는 <code>/* */</code>)을 모두 제거하세요`)
};

const ja_guide_json_syntax_errors_s6_li4 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コメント（<code>//</code>や<code>/* */</code>）をすべて削除してください`)
};

/**
* | output |
* | --- |
* | "Remove any comments (<code>//</code> or <code>/* *\/</code>)" |
*
* @param {Guide_Json_Syntax_Errors_S6_Li4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_s6_li4 = /** @type {((inputs?: Guide_Json_Syntax_Errors_S6_Li4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_S6_Li4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_s6_li4(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_s6_li4(inputs)
	return ja_guide_json_syntax_errors_s6_li4(inputs)
});